import type { ApiResponse } from '../../api/contract';

type ReportingResponse = ApiResponse<'/api/v1/reports/transactions', 'get'>;

export type ReportKind =
  | 'transactions'
  | 'agent-commissions'
  | 'affiliate-commissions'
  | 'games'
  | 'registrations'
  | 'partner-reconciliation'
  | 'commission-rule-usage'
  | 'audit-activity'
  | 'wallets'
  | 'wallet-ledger'
  | 'withdrawals'
  | 'partner-credit-reconciliation'
  | 'user-affiliate-by-game';

export type ReportRow = ReportingResponse['data'][number];
export type ReportCurrencyTotals = ReportingResponse['totals'][number];
export type ReportMeta = ReportingResponse['meta'];
export type ReportTimeBasis = ReportMeta['timeBasis'];
export type ReportSort = 'occurredAt' | 'amount' | 'code' | 'name';

export interface ReportFilters {
  readonly from: string;
  readonly to: string;
  readonly timezone: string;
  readonly timeBasis: ReportTimeBasis | '';
  readonly partnerId: string;
  readonly agentId: string;
  readonly memberId: string;
  readonly uplineMemberId: string;
  readonly gameTypeId: string;
  readonly gameId: string;
  readonly currency: string;
  readonly status: string;
  readonly outcome: string;
  readonly code: string;
  readonly username: string;
  readonly partnerUserId: string;
  readonly entryType: string;
  readonly sort: string;
}

export interface ReportQuery {
  readonly filters: ReportFilters;
  readonly cursor: string;
  readonly limit: number;
}

export interface ReportResult {
  readonly rows: readonly ReportRow[];
  readonly totals: readonly ReportCurrencyTotals[];
  readonly meta: ReportMeta;
  readonly nextCursor: string | null;
  readonly requestId: string | null;
}

export const emptyReportFilters = Object.freeze<ReportFilters>({
  from: '',
  to: '',
  timezone: 'Asia/Bangkok',
  timeBasis: '',
  partnerId: '',
  agentId: '',
  memberId: '',
  uplineMemberId: '',
  gameTypeId: '',
  gameId: '',
  currency: '',
  status: '',
  outcome: '',
  code: '',
  username: '',
  partnerUserId: '',
  entryType: '',
  sort: '',
});

export const defaultReportQuery = Object.freeze<ReportQuery>({
  filters: emptyReportFilters,
  cursor: '',
  limit: 50,
});
